import { createApiCaller, createApiClient } from "./client";
import { BASE_URL_SEARCH } from "../constants";

const client = createApiClient(BASE_URL_SEARCH, {
  getExtraHeaders: () => {
    const deviceId = localStorage.getItem("config_state_hash");
    if (!deviceId) return {};
    try {
      return { config_state_hash: JSON.parse(deviceId) };
    } catch (err) {
      return {};
    }
  },
});

export default createApiCaller(client);
